import createWeighInListsPdf from './createWeighInListsPdf';
import { createAthleteRecord } from '../common';
import DownloadsPicker from '../DownloadsPicker';
import FileDownload from '../../../components/FileDownload';

import React from 'react';
import { mapValues } from 'lodash';

const createWeighInLists = (sessions, mode) => {
  switch (mode) {
    default:
      return sessions.map(session => ({
        title: `${session.number}: ${session.title}`,
        athletes: session.entries.map(createAthleteRecord),
      }));
  }
};

const WeighInListsDownload = ({ sessions, mode, meta, ...props }) => {
  const onFileContents = () => {
    return createWeighInListsPdf(createWeighInLists(sessions, mode), meta);
  };
  return (
    <FileDownload
      mimeType="appication/pdf"
      fileName={`weigh-in-lists-${mode}.pdf`}
      onContents={onFileContents}
      {...props}
    />
  );
};

const WeighInListsDownloads = ({ sessions, meta }) => {
  const modes = mapValues(
    {
      all: 'All lists',
      //template: 'Empty template',
      //...(process.env.NODE_ENV !== 'production' ? { test: 'Test list' } : {}),
    },
    (text, mode) => ({
      mode,
      text,
      download: (
        <WeighInListsDownload mode={mode} sessions={sessions} meta={meta} />
      ),
    }),
  );

  return <DownloadsPicker modes={modes} />;
};

export default WeighInListsDownloads;



// WEBPACK FOOTER //
// ./src/pages/Home/weighInLists/WeighInListsDownloads.js